import * as React from 'react';
import { Modal } from '@traceair/tds';
import { style } from 'typestyle';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const LeaveDialog: React.FC<Props> = ({ isOpen, onCancel, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    size="s"
    title="Leave without saving?"
    description="Are you sure you want to leave this page? All unsaved changes will be lost."
    closableByOverlayClick
    onClose={onCancel}
    cancelButtonProps={{ text: 'Cancel', onClick: onCancel }}
    okButtonProps={{ text: 'Leave', type: 'danger', onClick: onConfirm }}
    className={style({
      $nest: {
        '& .ta-modal-body': { padding: 0 },
      },
    })}
  />
);
